


















import { Component, Vue } from "vue-property-decorator";
import { Getter, State, Mutation } from "vuex-class";
import Tabs from "./Tabs.vue";
import SchemeItem from "./SchemeItem.vue";
import { ProductTypes } from "defi/constants";

@Component({
  components: {
    Tabs,
    SchemeItem
  }
})
class Shemes extends Vue {
  @Getter("defi/schemes/getSchemesByType") getSchemesByType;

  @State(state => state.defi.schemes.activeIndex) activeIndex;

  @State(state => state.defi.schemes.loading) loading;

  @Mutation("defi/schemes/SET_ACTIVE_INDEX") setActiveIndex;

  get typeIndex() {
    return this.activeIndex;
  }

  set typeIndex(value) {
    this.setActiveIndex(value);
  }

  get type() {
    return this.types[this.typeIndex]?.value ?? ProductTypes[0];
  }

  get types() {
    return ProductTypes.filter(type => {
      return this.getSchemesByType(type)?.length > 0;
    }).map(t => ({
      text: this.$t(`defi.type-${t}`),
      value: t
    }));
  }

  get groups() {
    return this.types.map(type => type.text);
  }

  get schemes() {
    return this.getSchemesByType(this.type);
  }
}
export default Shemes;
